import styled from "styled-components";


const NavBar = () => {
  return (
  <Nav>

  </Nav>
  )
};

const Nav = styled.section`

background-color: red;
/* display: flex; */
width: 100%;
height: 2rem;





`;

export default NavBar;
